import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setResetCases } from '../../../redux/cases'
import { stepReset } from '../../../redux/steps'
import CheckIcon from '../../../assets/icons/check_bg_green.svg'
import {
  Container,
  SuccessImage,
  SuccessWrapper,
  SuccesImageWrapper,
  SuccessTitle,
  SubtitleSection,
  SuccessSubTitle,
  ButtonsWrapper,
  Button
} from '../CaseSendedNotReferible/styles'
import './styles'

export function CaseSendedReferableNotReferred () {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleResetCase = () => {
    dispatch(setResetCases())
    dispatch(stepReset())
  }

  const handleGoToHome = () => {
    history.replace('/home')
    handleResetCase()
  }

  return (
    <Container>
      <SuccessWrapper>
        <SuccesImageWrapper>
          <SuccessImage src={CheckIcon} alt='success' />
        </SuccesImageWrapper>

        <SuccessTitle> Control finalizado </SuccessTitle>

        <SubtitleSection>
          <SuccessSubTitle>
            La IA detectó signos compatibles con la retinopatía diabética, pero usted ha decidido no referir el estudio a un oftalmólogo.<br />
            El estudio fue enviado por correo electrónico para que lo conserve.<br />
            Le enviaremos un recordatorio dentro de 10 meses para que vuelva a repetir el control.<br />
          </SuccessSubTitle>
        </SubtitleSection>

        <ButtonsWrapper>
          <Button onClick={handleGoToHome}> Volver al inicio </Button>
          <Button highlighted onClick={handleResetCase}> Realizar nuevo estudio </Button>
        </ButtonsWrapper>
      </SuccessWrapper>
    </Container>
  )
}

export default CaseSendedReferableNotReferred
